import React from 'react';
import NftImage from './NftImage';

function NftPreview({ nft }) {
  return (
    <div>
      <div className='relative mb-4 overflow-hidden bg-gray-800 rounded-md aspect-square'>
        <a
          href={`https://www.nftexplorer.app/asset/${nft.index || nft.id}`}
          target={'_blank'}
          rel='noreferrer'
          className='absolute inset-0 w-full h-full'
        >
          <NftImage nft={nft} spinnerDimensionClasses='w-12 h-12' />
        </a>
      </div>
      <div className='flex flex-col items-center space-y-1 text-center'>
        <h2 className='text-sm'>{nft?.params?.name}</h2>
      </div>
    </div>
  );
}

export default NftPreview;
